// extracted by mini-css-extract-plugin
export default {"BoxBorderLoader_loader_wrapper":"loader_BoxBorderLoader_loader_wrapper__SYzw9","BoxBorderLoader":"loader_BoxBorderLoader__HS9js","load":"loader_load__9cIXr"};